<div [formGroup]="addressForm" (focusout)="onBlur()">

	<ms-input-label [isRequired]="isFieldRequired('country')" [labelText]="'Country'"
		[tooltip]="countryTooltip()" />
	<ms-country-dropdown id="country" formControlName="country"
		[(selectedCountry)]="selectedCountry" (selectedCountryChange)="selectedCountryChange()"></ms-country-dropdown>

	<ms-input-label [isRequired]="isFieldRequired('primaryAddress')" [labelText]="'Address Line 1'" class="mt-3" />
	<input type="text" id="primaryAddress" [required]="isFieldRequired('primaryAddress')" maxlength="50"
		formControlName="primaryAddress" class="form-control"
		[class.is-invalid]="addressForm.get('primaryAddress')?.invalid && addressForm.get('primaryAddress')?.touched"
		[class.is-valid]="addressForm.get('primaryAddress')?.valid && addressForm.get('primaryAddress')?.touched && addressForm.get('primaryAddress')?.value !== ''" />
	@if(addressForm.get('primaryAddress')?.invalid && addressForm.get('primaryAddress')?.touched) {
	<div class="error-messages">
		@if(addressForm.get('primaryAddress')?.errors?.['required']) {
		<p class="text-danger text-start pt-1 mb-0">{{FormValidatorMessages.PrimaryAddressRequired}}</p>
		}
	</div>
	}

	<ms-input-label [isRequired]="isFieldRequired('secondaryAddress')" [labelText]="'Address Line 2'" class="mt-3" />
	<input type="text" id="secondaryAddress" [required]="isFieldRequired('secondaryAddress')" maxlength="50"
		formControlName="secondaryAddress" class="form-control"
		[class.is-invalid]="addressForm.get('secondaryAddress')?.invalid && addressForm.get('secondaryAddress')?.touched"
		[class.is-valid]="addressForm.get('secondaryAddress')?.valid && addressForm.get('secondaryAddress')?.touched && addressForm.get('secondaryAddress')?.value !== ''" />

	<ms-input-label [isRequired]="isFieldRequired('city')" [labelText]="'City'" class="mt-3" />
	<input type="text" id="city" [required]="isFieldRequired('city')" maxlength="50" formControlName="city"
		class="form-control"
		[class.is-invalid]="addressForm.get('city')?.invalid && addressForm.get('city')?.touched"
		[class.is-valid]="addressForm.get('city')?.valid && addressForm.get('city')?.touched && addressForm.get('city')?.value !== ''" />
	@if(addressForm.get('city')?.invalid && addressForm.get('city')?.touched) {
	<div class="error-messages">
		@if(addressForm.get('city')?.errors?.['required']) {
		<p class="text-danger text-start pt-1 mb-0">{{FormValidatorMessages.CityRequired}}</p>
		}
	</div>
	}

	<ms-input-label [isRequired]="isFieldRequired('stateProvince')" [labelText]="'State / Province'" class="mt-3" />
	<ms-state-province-dropdown formControlName="stateProvince" [formGroup]="addressForm"
		[selectedCountry]="selectedCountry()"></ms-state-province-dropdown>

	<ms-input-label [isRequired]="isFieldRequired('zipPostal')" [labelText]="'Zip / Postal Code'" class="mt-3" />
	<input type="text" id="zipPostal" [required]="isFieldRequired('zipPostal')" maxlength="20"
		formControlName="zipPostal" class="form-control"
		[mask]="zipPostalMaskPattern()" [showMaskTyped]="false"
		[dropSpecialCharacters]="zipPostalSeparatorsToDrop"
		[class.is-invalid]="addressForm.get('zipPostal')?.invalid && addressForm.get('zipPostal')?.touched"
		[class.is-valid]="addressForm.get('zipPostal')?.valid && addressForm.get('zipPostal')?.touched && addressForm.get('zipPostal')?.value !== ''" />
	@if(addressForm.get('zipPostal')?.invalid && addressForm.get('zipPostal')?.touched) {
	<div class="error-messages">
		@if(addressForm.get('zipPostal')?.errors?.['required']) {
		<p class="text-danger text-start pt-1 mb-0">{{FormValidatorMessages.ZipPostalRequired}}</p>
		}

		@if(addressForm.get('zipPostal')?.errors?.['pattern']) {
		<p class="text-danger text-start pt-1 mb-0" [innerHTML]="zipPostalInvalidPatternValidatorMessage()"></p>
		}
	</div>
	}

</div>
